<div class="message-container"
     [class.selected]="selectedThreadId === thread?.id">
    <div class="checkbox-unread-container">
        <input type="checkbox"
       class="inbox-check-box"
       [checked]="selected"
       (change)="onCheckboxChanged($event)" />
        @for (participant of thread?.participants; track participant.id) {
            @if (participant.user_id === userId && !participant.read) {
                <span class="unread-thread-icon"></span>
            }
        }
    </div>
    <div class="thread-detail" (click)="handleClick()" (keydown.enter)="handleClick()" tabindex="0">
        <div class="author-date-container">
            <div class="author-subject-container">
                <span class="author">
                    @if (thread?.sender_id) {
                        {{ thread?.sender?.person?.given_name }} {{ thread?.sender?.person?.family_name }}
                    } @else {
                        <cll-badge>System Message</cll-badge>
                    }
                </span>
                <span class="thread-subject">
                    {{ thread?.subject }}
                </span>
            </div>
            <span class="message-date">{{ thread?.created_at | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <span class="thread-message">{{ lastMessage?.content }}</span>
    </div>
</div>
